import { SSE } from './sse-subscription.reducer';

export const selectSSE = (state) => state[SSE];
